<template>
  <div>
    <b-form-group
          id="addReferenceGroup1"
          label="Référence"
          label-for="addReference"
    >
      <b-form-input
        id="addReference"
        type="text"
        v-model="code"
        required
        :disabled="readOnly"
        placeholder="Entrez l'ID kanban"
        aria-describedby="exampleInput1Feedback"
        :state="testIfKanbanIdIsOk"
        v-uppercase/>
      <b-form-invalid-feedback id="exampleInput1Feedback">
        Entrez une id correct comme : EJA001D01
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>
<script>
// /!\ CODE CONSTRUCTION FOR EMPLACEMENT = ZONE + POS_Y + POS_X + POS_Z
//                                       =  S   +   Z   +   7   +   A
import server from '../../api/server.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CodeSelector',
  props: {
      readOnly: {
        type: Boolean,
        default: false
      }
    },
  data() {
    return {
      code: ''
    };
  },
  computed: {
    testIfKanbanIdIsOk() {
      var re = new RegExp("[A-Z]{3}[0-9]{3}[A-Z]{1}[0-9]{2}")
      if (re.test(this.code)) {
        this.$store.commit('setSelectedCode', this.code)
      } else {
        this.$store.commit('setSelectedCode', '')
      }
      return re.test(this.code)
    },
    ...mapGetters({
      form: 'getFormKanban'
    })
  },
  methods: {
  },
  mounted: function () {
  },
  components: {  }
};
</script>



// WEBPACK FOOTER //
// src/components/kanban/CodeSelector.vue